/* uuhu-pages.js — 施策J2(固定ページの組み直し)。書き込みは scripts/apply_design_j2.py */
(function () {
  'use strict';
  var d = document;
  var path = decodeURIComponent(location.pathname).replace(/\/$/, '');

  function unwrapImgs(root) {
    /* Shopify のエディタは <img> を <p> で包む。空の <p> ごと外して並べやすくする */
    Array.prototype.slice.call(root.querySelectorAll('p')).forEach(function (p) {
      if (p.querySelector('img') && p.textContent.trim() === '') {
        while (p.firstChild) p.parentNode.insertBefore(p.firstChild, p);
        p.parentNode.removeChild(p);
      } else if (!p.textContent.trim() && !p.querySelector('img')) {
        p.parentNode.removeChild(p);
      }
    });
  }

  /* 1) UUHUについて: h2 ごとに区切り、写真のある区切りは「文 | 写真」の2列に(左右を交互に) */
  if (path.slice(-12) === '/pages/about') {
    var wrap = d.querySelector('.main-page-title') && d.querySelector('.main-page-title').parentNode;
    var rte = d.querySelector('.main-page-title + .rte');
    if (wrap && rte) {
      wrap.classList.add('uuhu-about');
      unwrapImgs(rte);
      var kids = Array.prototype.slice.call(rte.children);
      var groups = [], cur = null;
      kids.forEach(function (el) {
        if (el.tagName === 'H2') { cur = { items: [el] }; groups.push(cur); }
        else if (cur) { cur.items.push(el); }
      });
      var n = 0;
      groups.forEach(function (g) {
        var imgs = g.items.filter(function (el) { return el.tagName === 'IMG'; });
        var row = d.createElement('section');
        rte.insertBefore(row, g.items[0]);
        if (imgs.length) {
          row.className = 'uuhu-about-row uuhu-about-row--media' + (n % 2 ? ' is-reverse' : '');
          n += 1;
          var text = d.createElement('div'); text.className = 'uuhu-about-row__text';
          var media = d.createElement('div'); media.className = 'uuhu-about-row__media';
          g.items.forEach(function (el) { (el.tagName === 'IMG' ? media : text).appendChild(el); });
          row.appendChild(text); row.appendChild(media);
        } else {
          row.className = 'uuhu-about-row uuhu-about-row--full';
          g.items.forEach(function (el) { row.appendChild(el); });
        }
      });
    }
  }

  /* 2) ギフト対応について: 先頭の「h3(種類と値段) + 写真 + 説明」×4 をカードに並べ、
        「こちらからご購入いただけます」の1行を、下の商品の欄へ飛ぶボタンにする */
  if (path.slice(-20) === '/pages/gift-wrapping') {
    var rte2 = d.querySelector('.main-page-title + .rte');
    var product = d.querySelector('[id$="__gift_product"]');
    if (rte2) {
      unwrapImgs(rte2);
      var kids2 = Array.prototype.slice.call(rte2.children);
      var cards = [], c = null;
      for (var i = 0; i < kids2.length; i++) {
        var el = kids2[i];
        if (el.tagName === 'H2') break;                       /* 「どんな贈り物に向きますか」から先は触らない */
        if (el.tagName === 'H3') { c = { h: el, imgs: [], ps: [] }; cards.push(c); continue; }
        if (!c) continue;
        if (el.tagName === 'IMG') c.imgs.push(el);
        else if (el.tagName === 'P') {
          if (/ご購入いただけます/.test(el.textContent) && product) {
            var cta = d.createElement('p'); cta.className = 'uuhu-gift-cta';
            var a = d.createElement('a'); a.className = 'button'; a.href = '#' + product.id;
            a.textContent = 'ギフト包装をカートに入れる';
            cta.appendChild(a); el.parentNode.replaceChild(cta, el); c = null;
          } else { c.ps.push(el); }
        }
      }
      if (cards.length >= 2) {
        var grid = d.createElement('ul'); grid.className = 'uuhu-gift-cards';
        rte2.insertBefore(grid, cards[0].h);
        cards.forEach(function (k) {
          var li = d.createElement('li'); li.className = 'uuhu-gift-card';
          var media = d.createElement('div'); media.className = 'uuhu-gift-card__media';
          k.imgs.forEach(function (im) { media.appendChild(im); });
          var body = d.createElement('div'); body.className = 'uuhu-gift-card__body';
          body.appendChild(k.h); k.ps.forEach(function (p) { body.appendChild(p); });
          if (k.imgs.length) li.appendChild(media);
          li.appendChild(body); grid.appendChild(li);
        });
      }
    }
  }
})();
